import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { settings } from '../../../settings';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  api = settings.API_URL;
  loginData: any = null;
  userData: any = null;
  selectedTableSizeItems: number = 10;
  tableFilterDropdownValue: any;
  constructor(private http: HttpClient) {}

  addDocument(params: any): Observable<any> {
    const headers = new HttpHeaders({
      responseType: 'text',
      'Content-Type': 'application/json-patch+json',
    });
    return this.http.post(
      this.api + `/api/Documents?sessionHash=${params.sessionHash}`,
      params,
      { headers, responseType: 'text' },
    );
  }

  editDocument(params: any): Observable<any> {
    const headers = new HttpHeaders({
      accept: 'text/plain',
    });
    let apiUrl: any;
    if (params.expirationDate && params.issueDate) {
      apiUrl =
        this.api +
        `/api/Documents/${params.documentId}?sessionHash=${params.sessionHash}&expirationDate=${params.expirationDate}&issueDate=${params.issueDate}`;
    } else if (params.expirationDate) {
      apiUrl =
        this.api +
        `/api/Documents/${params.documentId}?sessionHash=${params.sessionHash}&expirationDate=${params.expirationDate}`;
    } else if (params.issueDate) {
      apiUrl =
        this.api +
        `/api/Documents/${params.documentId}?sessionHash=${params.sessionHash}&issueDate=${params.issueDate}`;
    } else {
      apiUrl =
        this.api +
        `/api/Documents/${params.documentId}?sessionHash=${params.sessionHash}`;
    }
    return this.http.put(apiUrl, { headers }, { responseType: 'text' });
  }

  getDocuments(params: any): Observable<any> {
    return this.http.get(
      this.api +
        `/api/Documents?sessionHash=${params.sessionHash}&referenceType=${params.referenceType}&referenceId=${params.referenceId}`,
    );
  }

  getDocumentTypes(params: any): Observable<any> {
    let apiUrl: any;
    if (params.entityTypeValue) {
      apiUrl =
        this.api +
        `/api/DocumentTypes?sessionHash=${params.sessionHash}&referenceType=${params.referenceType}&entityTypeValue=${params.entityTypeValue}`;
    } else {
      apiUrl =
        this.api +
        `/api/DocumentTypes?sessionHash=${params.sessionHash}&referenceType=${params.referenceType}`;
    }
    return this.http.get(apiUrl, { responseType: 'text' });
  }

  deleteDocument(params: any): Observable<any> {
    const headers = new HttpHeaders({
      accept: 'text/plain',
      'Content-Type': 'application/json',
    });
    return this.http.delete(
      this.api +
        `/api/Documents/${params.documentId}?sessionHash=${params.sessionHash}`,
      { headers, responseType: 'text' },
    );
  }

  viewDocument(params: any): Observable<any> {
    return this.http.get(
      this.api +
        `/api/Documents/content/${params.documentId}?sessionHash=${params.sessionHash}`,
    );
  }

  downloadDocument(params: any): Observable<any> {
    return this.http.get(
      this.api +
        `/api/Documents/content/${params.documentId}?sessionHash=${params.sessionHash}`,
    );
  }
}
